import React, { useState } from "react";
import AppHeader from "./AppHeader";
import AppSidebar from "./AppSidebar";
import AppRoutes from "./AppRoutes";
import ScrollToTop from "../Common/ScrollToTop";
import ErrorDialog from "../Dialog/ErrorDialog";
import GlobalBanner from "./GlobalBanner";

const WarningBanner = () => {
  const bannerText = process.env.REACT_APP_BANNER_TEXT;
  
  if (!bannerText) {
    return null;
  }

  return (
    <div className="bg-yellow-500 text-yellow-900 px-4 py-3 flex items-center justify-center gap-2">
      <svg 
        className="w-5 h-5 flex-shrink-0" 
        fill="currentColor" 
        viewBox="0 0 20 20"
        aria-hidden="true"
      >
        <path 
          fillRule="evenodd" 
          d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" 
          clipRule="evenodd" 
        />
      </svg>
      <span className="font-medium text-sm">{bannerText}</span>
    </div>
  );
};

export default function MainLayout({
  userLoggedIn,
  myAppsCount,
  inboxCount,
  myUsersCount,
  myArchiveCount,
  setShowLoading,
  showLoading,
  errorDialogOpen,
  doLogOut,
  queryClient,
  isConnected,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen((prevState) => !prevState);
  };

  const closeSidebar = () => {
    setIsOpen(false);
  };

  return (
    <>
      <WarningBanner />
      <AppHeader
        userLoggedIn={userLoggedIn}
        isOpen={isOpen}
        toggleSidebar={toggleSidebar}
      />

      <GlobalBanner userLoggedIn={userLoggedIn} />

      <ScrollToTop />
      
      <main>
        <div
          className={`mx-auto px-6 flex flex-row justify-between md:space-x-8 bg-slate-50 ${
            isOpen ? "py-0" : "py-10"
          } sm:${isOpen ? "py-0" : "py-10"}`}
        >
          <AppSidebar
            userLoggedIn={userLoggedIn}
            isOpen={isOpen}
            closeSidebar={closeSidebar}
            myAppsCount={myAppsCount}
            inboxCount={inboxCount}
            myUsersCount={myUsersCount}
            myArchiveCount={myArchiveCount}
            doLogOut={doLogOut}
          />

          <div className={`${isOpen ? "hidden" : "w-full min-w-0"}`}>
            <AppRoutes
              userLoggedIn={userLoggedIn}
              setShowLoading={setShowLoading}
              queryClient={queryClient}
              isConnected={isConnected}
            />
          </div>
        </div>

        {showLoading && (
          <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"></div>
            <h2 className="text-center text-white text-xl font-semibold">
              Please Wait...
            </h2>
            <p className="w-1/3 text-center text-white"></p>
          </div>
        )}
        
        <ErrorDialog
          open={errorDialogOpen}
          onClose={() => doLogOut()}
          title="Error"
          children={
            <p>
              Your trial has expired. Please get in touch to extend or
              purchase this service. Thanks!
            </p>
          }
          onConfirm={() => doLogOut()}
        />
      </main>
    </>
  );
}

